module.exports = __webpack_public_path__ + "img/Nkeiruka.3ba216af.png";